// src/redux/actionTypes.js
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
